


























































import Accordion from '@/core/layout/Accordion.vue';
import { TDirectory, TFile } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Directory extends Vue {
    @Prop({ required: true, type: Object })
    directory!: TDirectory;

    @Prop({ required: false, type: Boolean, default: false })
    canSelectFolder!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    canCreateFolder!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    canCreateFiles!: boolean;

    @Prop({ required: false })
    selectedFile!: TFile | TFile[] | null;

    @Prop({ default: false })
    loading!: boolean;

    showFolderCreateInput = false;
    newFolderName = '';
    showFileCreateInput = false;
    newFileName = '';

    get files() {
        return this.directory.files;
    }

    get children() {
        return this.directory.children;
    }

    selectFiles(file: TFile | TFile[]) {
        this.$emit('select-files', Array.isArray(file) ? file : [file]);
    }

    selectDirectory() {
        if (!this.canSelectFolder) return;
        this.$emit('select-files', this.files);
    }

    createFolder(folderPath?: string) {
        if (!this.canCreateFolder) return;
        this.$emit('create-folder', folderPath ?? `${this.directory.fullPath}/${this.newFolderName}`.replace(/\\/g, '/'));
        this.newFolderName = '';
        this.showFolderCreateInput = false;
    }

    createFile(filePath?: string) {
        if (!this.canCreateFiles) return;
        this.$emit('create-file', filePath ?? `${this.directory.fullPath}/${this.newFileName}`.replace(/\\/g, '/'));
        this.newFileName = '';
        this.showFileCreateInput = false;
    }

    isSelected() {
        if (this.selectedFile == null) return false;

        if (Array.isArray(this.selectedFile)) {
            const files = this.selectedFile as TFile[];
            return files.some(file => {
                const paths = file.fullPath.replace(/\\/g, '/').split('/').filter(x => !!x);
                return paths[this.directory.level] === this.directory.name;
            });
        } else {
            const file = this.selectedFile as TFile;
            const paths = file.fullPath.replace(/\\/g, '/').split('/').filter(x => !!x);
            return paths[this.directory.level] === this.directory.name;
        }
    }

    mounted() {
        this.$nextTick(() => {
            const selected = this.isSelected();
            if (selected) {
                this.open();
            }
        });
    }

    public open(includeChildren = false) {
        this.$refs.accordion.open();
        if (includeChildren) {
            if (Array.isArray(this.$refs.children)) {
                for (const directory of this.$refs.children) {
                    directory.open(true);
                }
            } else if (this.$refs.children) {
                (this.$refs.children as any).open();
            }
        }
    }

    public close(includeChildren = false) {
        this.$refs.accordion.close();
        if (includeChildren) {
            if (Array.isArray(this.$refs.children)) {
                for (const directory of this.$refs.children) {
                    directory.close(true);
                }
            } else if (this.$refs.children) {
                (this.$refs.children as any).close();
            }
        }
    }

    public $refs!: {
        accordion: Accordion;
        children: any[];
    }
}
